@if (batch; as b) {
  <nz-page-header nzBackIcon (nzBack)="back()" [nzGhost]="false">
    <nz-page-header-title>
      <span>
        <ng-container i18n>po</ng-container>
        {{ b.poName }}/{{ b.sequenceInPo + 1 }}</span
      ></nz-page-header-title
    >
    <nz-page-header-tags>
      <nz-tag nzColor="blue">
        <app-batch-status-icon [status]="b.state"></app-batch-status-icon>
        <span>{{ b.state | i18nSelect: poStateTranslation }}</span>
      </nz-tag>
    </nz-page-header-tags>
    <nz-page-header-extra>
      @if (neighbors?.after || neighbors?.before) {
        <div class="batch-nav">
          @if (neighbors?.after; as afterBatch) {
            <a class="batch-nav__link" [routerLink]="['/pos', afterBatch.id]"
               nz-tooltip i18n-nzTooltipTitle nzTooltipTitle="Next batch in sequence">
              <span>{{ afterBatch.poName }}/{{ afterBatch.sequenceInPo + 1 }}</span>
              <span nz-icon nzType="left"></span>
            </a>
          }
          @if (neighbors?.before; as beforeBatch) {
            <a class="batch-nav__link" [routerLink]="['/pos', beforeBatch.id]"
               nz-tooltip i18n-nzTooltipTitle nzTooltipTitle="Previous batch in sequence">
              <span nz-icon nzType="right"></span>
              <span>{{ beforeBatch.poName }}/{{ beforeBatch.sequenceInPo + 1 }}</span>
            </a>
          }
        </div>
      }
      <nz-space>
        @if (b | canTransit: PoState.Split) {
          <ng-template nzSpaceItem>
            <button nz-button [disabled]="!authState.hasAnyRole(UserRole.Operator, UserRole.Admin)" (click)="openSplitDialog()">
              <span nz-icon nzType="copy"></span>
              <span i18n>Split New Batch</span>
            </button>
          </ng-template>
        }
        @if (b | canTransit: PoState.Suspended) {
          <ng-template nzSpaceItem>
            <button nz-button (click)="state.suspend(b.id)">
              <span nz-icon nzType="pause-circle"></span>
              <span i18n>Suspend</span>
            </button>
          </ng-template>
        }
        @if (b | canTransit: PoState.Suspended) {
          <ng-template nzSpaceItem>
            <button nz-button [disabled]="!authState.hasAnyRole(UserRole.Operator, UserRole.Admin)" (click)="authState.hasAnyRole(UserRole.Operator, UserRole.Admin) && truncateDialog.show()">
              <span nz-icon nzType="scissor"></span>
              <span i18n>Truncate</span>
            </button>
          </ng-template>
        }
        @if (b | canTransit: PoState.Running) {
          <ng-template nzSpaceItem>
            <button nz-button [disabled]="!authState.hasAnyRole(UserRole.Operator, UserRole.Admin)" (click)="authState.hasAnyRole(UserRole.Operator, UserRole.Admin) && attachDialog.show(b)">
              <span nz-icon nzType="group"></span>
              <span i18n>Attach</span>
            </button>
          </ng-template>
        }
        @if (b | canTransit: PoState.Bypassed) {
          <ng-template nzSpaceItem>
            <button nz-button (click)="state.bypass(b.id)">
              <span nz-icon nzType="eye-invisible"></span>
              <span i18n>Bypass</span>
            </button>
          </ng-template>
        }
        @if (b | canTransit: PoState.IsInspected) {
          <ng-template nzSpaceItem>
            <button nz-button (click)="state.inspect(b.id)">
              <span nz-icon nzType="search"></span>
              <span i18n>Inspect</span>
            </button>
          </ng-template>
        }
        @if (b | canTransit: PoState.Aborted) {
          <ng-template nzSpaceItem>
            <button nz-button (click)="state.abort(b.id)">
              <span nz-icon nzType="delete"></span>
              <span i18n>Abort</span>
            </button>
          </ng-template>
        }
        @if (authState.hasRole(UserRole.Admin) && (b | canTransit: PoState.Ignored)) {
          <ng-template nzSpaceItem>
            <button nz-button (click)="state.ignore(b.id)">
              <span nz-icon nzType="delete"></span>
              <span i18n>Ignore</span>
            </button>
          </ng-template>
        }
        <ng-template nzSpaceItem>
          <nz-switch [(ngModel)]="showStatsAll"></nz-switch>
        </ng-template>
      </nz-space>
    </nz-page-header-extra>
    <nz-page-header-content>
      @if (lastScanLowConfidence) {
        <div class="low-confidence-alert" role="alert" i18n="@@poLowConfidenceWarning">
          Rare unknown color — confidence is low. Please pay attention!
        </div>
      }
      <nz-descriptions nzSize="small" [nzColumn]="3">
        <nz-descriptions-item i18n-nzTitle nzTitle="Producing" [nzSpan]="1"
          >{{ b.producingQuantity }} ({{ b.totalProducingQuantity }}
          <ng-container i18n>of</ng-container>
          {{ b.orderedQuantity }})
        </nz-descriptions-item>
        <nz-descriptions-item i18n-nzTitle nzTitle="Color" [nzSpan]="1">
          <app-formulation-color-preview [color]="b.color"></app-formulation-color-preview>
          {{ b.color?.code }}
        </nz-descriptions-item>
        <nz-descriptions-item i18n-nzTitle nzTitle="Ordered" [nzSpan]="1">{{ b.orderedTime | date: 'yyyy-MM-dd HH:mm:ss' }} </nz-descriptions-item>
        <nz-descriptions-item i18n-nzTitle nzTitle="Remaining" [nzSpan]="1">{{ b.remainingQuantity }} ({{ b.totalRemainingQuantity }}) </nz-descriptions-item>
        <nz-descriptions-item i18n-nzTitle nzTitle="Catalog" [nzSpan]="1"
          ><a routerLink="/catalogs">{{ b.catalog.name }} ({{ b.catalog.externalId }})</a>
        </nz-descriptions-item>
        <nz-descriptions-item i18n-nzTitle nzTitle="Started" [nzSpan]="1">{{ b.startedTime | date: 'yyyy-MM-dd HH:mm:ss' }} </nz-descriptions-item>
        <nz-descriptions-item i18n-nzTitle nzTitle="Inspected" [nzSpan]="1">{{ b.inspectedQuantity }} ({{ b.totalInspectedQuantity }}) </nz-descriptions-item>
        <nz-descriptions-item i18n-nzTitle nzTitle="Base Material" [nzSpan]="1"
          >{{ data[b.baseMaterialId.toString()] || b.baseMaterialId }}
        </nz-descriptions-item>
        <nz-descriptions-item i18n-nzTitle nzTitle="Last Inspected" [nzSpan]="1">{{ b.modifiedTime | date: 'yyyy-MM-dd HH:mm:ss' }} </nz-descriptions-item>
        <nz-descriptions-item i18n-nzTitle nzTitle="Failed" [nzSpan]="1">{{ b.failedQuantity }} ({{ b.totalFailedQuantity }}) </nz-descriptions-item>
        <nz-descriptions-item i18n-nzTitle nzTitle="Color LAB" [nzSpan]="1">
          L:{{ b.color?.lab?.l | number: '1.1-1' }}, A:{{ b.color?.lab?.a | number: '1.1-1' }}, B:{{ b.color?.lab?.b | number: '1.1-1' }}
        </nz-descriptions-item>
        <nz-descriptions-item i18n-nzTitle nzTitle="Stopped" [nzSpan]="1">{{ b.suspendedTime | date: 'yyyy-MM-dd HH:mm:ss' }} </nz-descriptions-item>
        <nz-descriptions-item i18n-nzTitle nzTitle="dE" [nzSpan]="1"
          >{{ b.dENatAvg | number: '1.2-2' }} ({{ b.dENatMax | number: '1.2-2' }})
        </nz-descriptions-item>
        <nz-descriptions-item i18n-nzTitle nzTitle="dC" [nzSpan]="1">{{ b.dCAvg | number: '1.2-2' }} ({{ b.dCMax | number: '1.2-2' }}) </nz-descriptions-item>
        @if (b.dEPairMax) {
          <nz-descriptions-item i18n-nzTitle nzTitle="Max Cross dE" [nzSpan]="1"
            >{{ b.dEPairMax | number: '1.2-2' }}
            <ng-container i18n>between buckets:</ng-container>
            {{ b.dEPairMaxIds[0] }}-{{ b.dEPairMaxIds[1] }}&nbsp;
            <label nz-checkbox [(ngModel)]="filterToMaxXdE"></label>
          </nz-descriptions-item>
        }
        <nz-descriptions-item i18n-nzTitle nzTitle="SAP Order ID" [nzSpan]="1">
          {{ b.sapCustomerOrderNum }}
        </nz-descriptions-item>
        <nz-descriptions-item i18n-nzTitle nzTitle="Comment" [nzSpan]="4">
          <div style="display: flex; gap: 4px; width: 100%">
            <input nz-input [(ngModel)]="batchComment" placeholder="Add comment..." style="flex: 1" />
            <button nz-button nzType="primary" (click)="saveBatchComment(b)">
              <span nz-icon nzType="save"></span>
            </button>
          </div>
        </nz-descriptions-item>
      </nz-descriptions>
    </nz-page-header-content>
  </nz-page-header>

  <nz-tabs [nzSelectedIndex]="mainTabIndex" (nzSelectedIndexChange)="onMainTabChange($event)">
    <nz-tab nzTitle="Images">
      <nz-list nzGrid class="po-list" id="poList">
        <div nz-row [nzGutter]="16">
          @for (s of scans(b); track s) {
            <div nz-col [nzSpan]="6">
              <nz-list-item>
                <app-scan-gallery-card
                  [scan]="s"
                  [referenceLab]="b.color?.lab"
                  [showStats]="s.id == showStatsScanId || showStatsAll"
                  (cardClick)="modelHandle(s.id)"
                  (statusChange)="updateScanStatus(s, $event)"
                  (hoverStart)="hoverStarted(s)"
                  (hoverEnd)="hoverEnded(s)"
                />
              </nz-list-item>
            </div>
          }
        </div>
      </nz-list>
    </nz-tab>
    <nz-tab nzTitle="Analysis">
      <app-batch-analysis *ngIf="b"
        [batch]="b"
        [model]="activeModel"
        (scanDialogRequested)="modelHandle($event.id)"></app-batch-analysis>
    </nz-tab>
  </nz-tabs>

  <app-scan-dialog
    i18n-extraActionTitle
    i18n-defaultActionTitle
    [scan]="scan && !(isBadBucket(scan) && scan.state === ScanStatus.Failed) ? scan : null"
    (onClose)="closeScanDialog()"
    (onBackward)="navScans(-1)"
    (onForward)="navScans(1)"
    (onStatusUpdate)="updateScanStatus(scan, $event)"
    [extraActionTitle]="authState.hasAnyRole(UserRole.Operator,UserRole.Laboratory,UserRole.Admin) ? 'ReInspect' : undefined"
    (onExtraAction)="reInspect(scan)"
    defaultActionTitle="Preview"
    (onAction)="preInspect(scan)"
    [closeOnDefaultAction]="false"
    [selectedTabIndex]="scanTabIndex"
    (selectedTabIndexChange)="onScanTabChange($event)"
  >
  </app-scan-dialog>

  <app-po-split-dialog #splitDialog [maxCount]="b.totalRemainingQuantity" (onUpdate)="split($event)"> </app-po-split-dialog>
  <app-po-split-dialog #truncateDialog [minCount]="b.inspectedQuantity" [maxCount]="b.producingQuantity" (onUpdate)="truncate($event)"> </app-po-split-dialog>
  <app-po-attach-dialog #attachDialog (onSelect)="attach($event)"></app-po-attach-dialog>
}
